import {Injectable} from '@angular/core';
import {loadModules} from 'esri-loader';

@Injectable({
    providedIn: 'root'
})
export class ArcgisNavigationOverride {
    constructor() {
        this.modifyMouseEvents();
    }

    private modifyMouseEvents(): void {
        loadModules(['esri/MouseEvents', 'esri/MapNavigationManager', 'dojo/_base/sniff', 'dojo/_base/event'])
            .then(([MouseEvents, MapNavigationManager, sniff, event]) => {
                // Patch MouseEvents._onMouseWheelHandler
                if (typeof MouseEvents.prototype._onMouseWheelHandler === 'function') {
                    MouseEvents.prototype._onMouseWheelHandler = function (a: any) {
                        let b = this.map;
                        if (b ? b.isScrollWheelZoom || b.isScrollWheelPan : this.preventPageScroll) {
                            event.stop(a);
                        }

                        if (sniff('ff') || sniff('mozilla')) {
                            b = -a.detail / this.mozWheelDivisor;
                        } else {
                            b = a.wheelDelta / this.wheelDivisor;
                        }

                        let c = Math.abs(b);
                        c = c <= this.minWheelValue ? this.minWheelValue : this.maxWheelValue;

                        a.value = b < 0 ? -c : c;

                        // Custom zoom values
                        a.value = a.value > 0 ? 3 / 2 : -2 / 3;

                        this._fire('onMouseWheel', this._processEvent(a));
                    };
                }

                // Patch MapNavigationManager._keyDown
                if (MapNavigationManager.prototype._keyDown) {
                    const originalKeyDown = MapNavigationManager.prototype._keyDown;

                    MapNavigationManager.prototype._keyDown = function (e: KeyboardEvent) {
                        if ([61, 107, 187].includes(e.keyCode)) {
                            // Zoom in keys
                            this.map._extentUtil({numLevels: 3 / 2});
                            event.stop(e);
                        } else if ([109, 173, 189].includes(e.keyCode)) {
                            // Zoom out keys
                            this.map._extentUtil({numLevels: -2 / 3});
                            event.stop(e);
                        } else {
                            originalKeyDown.apply(this, arguments);
                        }
                    };
                }
            })
            .catch(err => {
                console.error('ArcGIS loading error: ', err);
            });
    }
}
